/** Construye query params de advanced_filters para GET/POST /stock-movement */
export function buildMovementAdvancedFiltersParams(advancedFilters: {
  filters: Array<{
    column: string;
    operator: string;
    value?: string | string[] | number | number[] | null;
  }>;
  logic: string;
}): Record<string, string | number> {
  const params: Record<string, string | number> = {};

  if (!advancedFilters.filters?.length) {
    return params;
  }

  advancedFilters.filters.forEach((f, i) => {
    params[`advanced_filters[filters][${i}][column]`] = f.column;
    params[`advanced_filters[filters][${i}][operator]`] = f.operator;

    if (f.operator === 'is_null' || f.operator === 'is_not_null') {
      return;
    }

    if (f.operator === 'in' || f.operator === 'not_in') {
      const values = Array.isArray(f.value) ? f.value : f.value != null ? [f.value] : [];
      values.forEach((val, j) => {
        params[`advanced_filters[filters][${i}][value][${j}]`] = val;
      });
      return;
    }

    if (f.value !== undefined && f.value !== null && f.value !== '') {
      params[`advanced_filters[filters][${i}][value]`] = Array.isArray(f.value) ? f.value[0] : f.value;
    }
  });

  if (advancedFilters.logic) {
    params['advanced_filters[logic]'] = advancedFilters.logic;
  }

  return params;
}
